import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import 'rxjs/add/operator/switchMap';

import { SessionService } from '../../../core/services';
import { isAdmin } from '../../../shared/utils';

import { Address, Contact, Email, Phone } from '../../../core/data';
import { formatDatetimeForApi } from '../../utils';
import { AddressModalComponent } from './address-modal.component';
import { EmailModalComponent } from './email-modal.component';
import { PhoneModalComponent } from './phone-modal.component';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
})
export class ContactFormComponent {
  dropdownState: object = {};
  trashed = [];

  @Input() contact: Contact;
  @Output() onChange = new EventEmitter<Contact>();
  @ViewChild(AddressModalComponent) addressModal;
  @ViewChild(EmailModalComponent) emailModal;
  @ViewChild(PhoneModalComponent) phoneModal;

  saveAddress(address: Address) {
    this.emit({
      id: this.contact.id,
      addresses: [address],
    });

    this.addressModal.close();
  }

  constructor(private session: SessionService) {}

  // @TODO refactor to own service/helper
  get isAdmin() {
    return isAdmin(this.session.get('profile'));
  }

  get emails(): Email[] {
    return this.contact.emails.filter((email: Email) => this.isAdmin || !this.isTrashed(email));
  }

  get phones(): Phone[] {
    return this.contact.phones.filter((phone: Phone) => this.isAdmin || !this.isTrashed(phone));
  }

  get addresses(): Address[] {
    return this.contact.addresses.filter((address: Address) => this.isAdmin || !this.isTrashed(address));
  }

  isTrashed(model: Address | Phone | Email): boolean {
    return model.trashed || this.trashed.includes(model.id);
  }

  removeAddress(address: Address) {
    if (confirm('Are you sure you want to delete this address?')) {
      this.trashed.push(address.id);

      this.emit({
        id: this.contact.id,
        addresses: [{
          ...address,
          deleted_at: formatDatetimeForApi(new Date()),
        }]
      });
    }
  }

  saveEmail(email) {
    this.emit({
      id: this.contact.id,
      emails: [email],
    });

    this.emailModal.close();
  }

  removeEmail(email: Email) {
    if (confirm('Are you sure you want to delete this email?')) {
      this.trashed.push(email.id);

      this.emit({
        id: this.contact.id,
        emails: [{
          ...email,
          deleted_at: formatDatetimeForApi(new Date()),
        }]
      });
    }
  }

  savePhone(phone) {
    this.emit({
      id: this.contact.id,
      phones: [phone],
    });

    this.phoneModal.close();
  }

  removePhone(phone: Phone) {
    if (confirm('Are you sure you want to delete this contact number?')) {
      this.trashed.push(phone.id);

      this.emit({
        id: this.contact.id,
        phones: [{
          ...phone,
          deleted_at: formatDatetimeForApi(new Date()),
        }]
      });
    }
  }

  emit(contact: Contact) {
    this.onChange.emit(contact);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/contacts/contact-form.component.ts